/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import './dep-6f3e4f56.mjs';
import { a as _getNative } from './dep-e50fa7b0.mjs';
import { a as _root } from './dep-b1060562.mjs';

var getNative = _getNative,
  root = _root;

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');
var _Set = Set;

export { _Set as _ };
//# sourceMappingURL=dep-c57d8117.mjs.map
